import { Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';

interface Scope {
	loading: boolean;
}

@Component({
	selector: 'ms-button',
	templateUrl: './ms-button.component.html',
	styleUrls: ['./ms-button.component.scss'],
	encapsulation: ViewEncapsulation.None,
	standalone: false,
})
export class MsButtonComponent implements OnInit, OnDestroy {
	@Input() label: string | null;
	@Input() icon: string | null;
	@Input() action: string | null;
	@Input() disabled: boolean | null;
	@Input() class: string | null;
	@Input() title: string | null;
	@Input() outlined: boolean | false;
	@Input() styleClass: string | null;
	@Input() severity:
		| 'success'
		| 'info'
		| 'warn'
		| 'danger'
		| 'help'
		| 'primary'
		| 'secondary'
		| 'contrast'
		| null
		| undefined;
	@Input() size: 'small' | 'large' | undefined;
	@Input() raised: boolean | false;
	@Input() variant: 'outlined' | 'text' | undefined;
	@Input() noPadding: boolean | false;

	scope: Scope = {
		loading: false,
	};

	/**
	 * Constructor
	 */
	constructor() {}

	// -----------------------------------------------------------------------------------------------------
	// @ Lifecycle hooks
	// -----------------------------------------------------------------------------------------------------

	/**
	 * On init
	 */
	ngOnInit(): void {
		if (this.action === undefined) {
			this.action = 'button';
		}
		if (this.title === undefined) {
			this.title = this.label || '';
		}
		if (this.noPadding === true) {
			this.styleClass += ' p-button-icon-only-no-padding';
		}
	}

	/**
	 * On destroy
	 */
	ngOnDestroy(): void {}

	// -----------------------------------------------------------------------------------------------------
	// @ Public methods
	// -----------------------------------------------------------------------------------------------------

	// -----------------------------------------------------------------------------------------------------
	// @ Private methods
	// -----------------------------------------------------------------------------------------------------
}
